export default function OrgPackages() {
  return (
    <section
      id="orgPackages"
      className={`w-full md:min-h-screen flex flex-col justify-center relative`}
    >
      {/* Absolute Background */}
      <img
        className={`absolute left-0 top-0 max-xl:hidden`}
        src="/img/home/Rectangle 14.png"
        alt="Absolute bg"
      />
      <div
        className={`myContainer w-full flex flex-col min-h-full justify-center gap-5 md:gap-20`}
      >
        <span className={`text-black text-2xl lg:text-4xl font-bold`}>
          پکیج های اشتراک سازمانی
        </span>
        <div
          className={`w-full flex max-xl:flex-wrap justify-center xl:justify-between items-center max-w-[1440px] mx-auto gap-5 md:gap-11`}
        >
          <div
            className={`w-full xl:w-[calc(25%-22px)] max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] bg-[#E2EFEC] relative overflow-hidden`}
          >
            {/* Absolute Svg */}
            <svg
              className={`absolute right-0 top-0 z-0`}
              xmlns="http://www.w3.org/2000/svg"
              width="118"
              height="123"
              viewBox="0 0 118 123"
              fill="none"
            >
              <circle
                cx="83.6731"
                cy="38.7538"
                r="66.0577"
                stroke="url(#paint0_radial_7976_7402)"
                stroke-width="35.2308"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_7976_7402"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(35.2308 28.625) rotate(44.3069) scale(154.465)"
                >
                  <stop stop-color="#E2EFEC" />
                  <stop offset="1" stop-color="#B2BF63" />
                </radialGradient>
              </defs>
            </svg>

            <span className={`text-black text-2xl font-black z-10`}>
              پکیج رایگان
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <path
                d="M36.3521 59.9436C35.3727 60.2893 33.7596 60.2893 32.7802 59.9436C24.4268 57.0919 5.76111 45.1955 5.76111 25.0319C5.76111 16.1312 12.9336 8.92993 21.7767 8.92993C27.0192 8.92993 31.6568 11.4648 34.5661 15.3823C37.4754 11.4648 42.1419 8.92993 47.3556 8.92993C56.1987 8.92993 63.3712 16.1312 63.3712 25.0319C63.3712 45.1955 44.7055 57.0919 36.3521 59.9436Z"
                stroke="#34A853"
                strokeWidth="4.32075"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className={`flex flex-col gap-2 items-center`}>
              <span className="text-black font-semibold whitespace-nowrap">
                مدت زمان اشتراک ۷ روز
              </span>
              <span className="text-black font-semibold">۱ ادمین</span>
              <span className="text-black font-semibold">۱ دسته بندی چالش</span>
              <span className="text-black font-semibold">
                ۱ چالش فعال همزمان
              </span>
              <span className="text-black font-semibold">حداکثر ۵ کاربر</span>
              <span className="text-black font-black">قیمت: رایگان</span>
            </div>
          </div>
          <div
            className={`w-full xl:w-[calc(25%-22px)] max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] bg-[#FADFC3] relative overflow-hidden`}
          >
            {/* Absolute Svg */}
            <svg
              className={`absolute top-0 right-0 z-0`}
              xmlns="http://www.w3.org/2000/svg"
              width="118"
              height="123"
              viewBox="0 0 118 123"
              fill="none"
            >
              <circle
                cx="83.6731"
                cy="38.7538"
                r="66.0577"
                stroke="url(#paint0_radial_7976_7391)"
                stroke-width="35.2308"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_7976_7391"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(35.2308 28.625) rotate(44.3069) scale(154.465)"
                >
                  <stop stop-color="#FADEC3" />
                  <stop offset="1" stop-color="#BF9163" />
                </radialGradient>
              </defs>
            </svg>

            <span className={`text-black text-2xl font-black z-10`}>
              پکیج برنزی
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="77"
              height="77"
              viewBox="0 0 77 77"
              fill="none"
            >
              <path
                d="M44.4993 11.5039L50.1393 22.7839C50.9084 24.3541 52.9593 25.8603 54.6898 26.1487L64.9123 27.8471C71.4497 28.9367 72.9878 33.6794 68.2771 38.3581L60.3298 46.3054C58.9839 47.6513 58.2469 50.247 58.6635 52.1056L60.9387 61.9436C62.7332 69.7307 58.5994 72.743 51.7096 68.6732L42.1279 63.0011C40.3975 61.9757 37.5454 61.9757 35.7829 63.0011L26.2013 68.6732C19.3435 72.743 15.1776 69.6987 16.9721 61.9436L19.2474 52.1056C19.664 50.247 18.9269 47.6513 17.581 46.3054L9.63369 38.3581C4.95504 33.6794 6.46118 28.9367 12.9985 27.8471L23.221 26.1487C24.9194 25.8603 26.9704 24.3541 27.7395 22.7839L33.3795 11.5039C36.4559 5.38315 41.455 5.38315 44.4993 11.5039Z"
                stroke="#C4782A"
                stroke-width="4.80684"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className={`flex flex-col gap-2 items-center`}>
              <span className="text-black font-semibold whitespace-nowrap">
                مدت زمان اشتراک ۱ سال
              </span>
              <span className="text-black font-semibold">5 ادمین</span>
              <span className="text-black font-semibold">5 دسته بندی چالش</span>
              <span className="text-black font-semibold">
                5 چالش فعال همزمان
              </span>
              <span className="text-black font-semibold">حداکثر 20 کاربر</span>
              <span className="text-black font-black">
                قیمت: ۵۹ میلیون تومان
              </span>
            </div>
          </div>
          <div
            className={`w-full xl:w-[calc(25%-22px)] max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] bg-[#E3E5EC] relative overflow-hidden`}
          >
            {/* Absolute Svg */}
            <svg
              className={`absolute right-0 top-0 z-0`}
              xmlns="http://www.w3.org/2000/svg"
              width="118"
              height="123"
              viewBox="0 0 118 123"
              fill="none"
            >
              <circle
                cx="83.6731"
                cy="38.7538"
                r="66.0577"
                stroke="url(#paint0_radial_7976_7414)"
                stroke-width="35.2308"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_7976_7414"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(35.2308 28.625) rotate(45) scale(127.674)"
                >
                  <stop stop-color="#E3E5EC" />
                  <stop offset="1" stop-color="#CED0D6" />
                </radialGradient>
              </defs>
            </svg>

            <span className={`text-black text-2xl font-black z-10`}>
              پکیج نقره ای
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="83"
              height="83"
              viewBox="0 0 83 83"
              fill="none"
            >
              <path
                d="M41.4792 51.8492C54.3651 51.8492 64.8113 41.7899 64.8113 29.3813C64.8113 16.9726 54.3651 6.91333 41.4792 6.91333C28.5932 6.91333 18.1471 16.9726 18.1471 29.3813C18.1471 41.7899 28.5932 51.8492 41.4792 51.8492Z"
                stroke="#858588"
                stroke-width="5.18491"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M25.9929 46.7335L25.9584 72.2432C25.9584 75.3542 28.1361 76.8751 30.8323 75.5962L40.0959 71.2063C40.8564 70.8261 42.1353 70.8261 42.8958 71.2063L52.1941 75.5962C54.8556 76.8405 57.0679 75.3542 57.0679 72.2432V46.1113"
                stroke="#858588"
                stroke-width="5.18491"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className={`flex flex-col gap-2 items-center`}>
              <span className="text-black font-semibold whitespace-nowrap">
                مدت زمان اشتراک 1 سال
              </span>
              <span className="text-black font-semibold">۱0 ادمین</span>
              <span className="text-black font-semibold">
                10 دسته بندی چالش
              </span>
              <span className="text-black font-semibold">
                ۱0 چالش فعال همزمان
              </span>
              <span className="text-black font-semibold">حداکثر 100 کاربر</span>
              <span className="text-black font-black">
                قیمت: ۷۹ میلیون تومان
              </span>
            </div>
          </div>
          <div
            className={`w-full xl:w-[calc(25%-22px)] max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] bg-[#FFEFC4] relative overflow-hidden`}
          >
            {/* Absolute Svg */}
            <svg
              className={`absolute right-0 top-0 z-0`}
              xmlns="http://www.w3.org/2000/svg"
              width="118"
              height="123"
              viewBox="0 0 118 123"
              fill="none"
            >
              <circle
                cx="83.6731"
                cy="38.7538"
                r="66.0577"
                stroke="url(#paint0_radial_7976_7426)"
                stroke-width="35.2308"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_7976_7426"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(35.2308 28.625) rotate(45) scale(117.709)"
                >
                  <stop stop-color="#FFEFC4" />
                  <stop offset="1" stop-color="#CBA53F" />
                </radialGradient>
              </defs>
            </svg>

            <span className={`text-black text-2xl font-black z-10`}>
              پکیج طلایی
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="82"
              height="82"
              viewBox="0 0 82 82"
              fill="none"
            >
              <path
                d="M64.3072 30.4614C64.3072 35.3691 62.8518 39.8706 60.3472 43.6275C56.6918 49.0429 50.9042 52.8674 44.1688 53.849C43.0181 54.052 41.8335 54.1536 40.615 54.1536C39.3966 54.1536 38.212 54.052 37.0612 53.849C30.3259 52.8674 24.5382 49.0429 20.8829 43.6275C18.3783 39.8706 16.9229 35.3691 16.9229 30.4614C16.9229 17.3631 27.5167 6.76929 40.615 6.76929C53.7134 6.76929 64.3072 17.3631 64.3072 30.4614Z"
                stroke="#D3B155"
                stroke-width="5.07689"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M71.9228 62.5131L66.3382 63.833C65.0859 64.1376 64.1044 65.0854 63.8336 66.3377L62.649 71.313C62.0059 74.0207 58.5536 74.833 56.7598 72.7007L40.6153 54.1531L24.4708 72.7345C22.677 74.8668 19.2247 74.0545 18.5816 71.3468L17.397 66.3715C17.0924 65.1192 16.1109 64.1377 14.8924 63.8669L9.30783 62.547C6.73554 61.9377 5.8217 58.7223 7.68322 56.8608L20.8831 43.6609C24.5385 49.0762 30.3261 52.9009 37.0615 53.8824C38.2122 54.0855 39.3968 54.187 40.6153 54.187C41.8338 54.187 43.0184 54.0855 44.1691 53.8824C50.9045 52.9009 56.6921 49.0762 60.3475 43.6609L73.5474 56.8608C75.4089 58.6885 74.4951 61.9039 71.9228 62.5131Z"
                stroke="#D3B155"
                stroke-width="5.07689"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M42.578 20.2398L44.5749 24.2336C44.8457 24.7752 45.5564 25.3167 46.1995 25.4183L49.821 26.0275C52.1225 26.3998 52.6641 28.0921 51.0056 29.7505L48.1964 32.5597C47.7226 33.0335 47.4518 33.9474 47.621 34.6244L48.4333 38.1105C49.0764 40.852 47.621 41.935 45.1841 40.4796L41.7995 38.4827C41.1903 38.1104 40.1749 38.1104 39.5657 38.4827L36.1811 40.4796C33.7442 41.9012 32.2888 40.852 32.9319 38.1105L33.7442 34.6244C33.8796 33.9813 33.6427 33.0335 33.1688 32.5597L30.3596 29.7505C28.7012 28.0921 29.2427 26.4336 31.5442 26.0275L35.1657 25.4183C35.775 25.3167 36.4857 24.7752 36.7565 24.2336L38.7534 20.2398C39.7349 18.0737 41.4949 18.0737 42.578 20.2398Z"
                stroke="#D3B155"
                stroke-width="5.07689"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className={`flex flex-col gap-2 items-center`}>
              <span className="text-black font-semibold whitespace-nowrap">
                مدت زمان اشتراک 1 سال
              </span>
              <span className="text-black font-semibold">50 ادمین</span>
              <span className="text-black font-semibold">
                20 دسته بندی چالش
              </span>
              <span className="text-black font-semibold whitespace-nowrap">
                چالش فعال همزمان نامحدود
              </span>
              <span className="text-black font-semibold">
                تعداد کاربر نامحدود
              </span>
              <span className="text-black font-black">
                قیمت: ۹۹ میلیون تومان
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
